import { useState, useEffect, useCallback } from 'react'
import { getCardPricing } from '@/app/actions'
import _ from 'underscore'

interface PricingData {
  entityId: string
  code: string
  shipping: string
  card?: string
  packPrice: number
  list: any[]
  // Ajoutez d'autres propriétés selon vos besoins
}

interface UseCardPricingReturn {
  orgPricing: PricingData[]
  personalPricing: PricingData[]
  isLoading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export const useCardPricing = (): UseCardPricingReturn => {
  const [orgPricing, setOrgPricing] = useState<PricingData[]>([])
  const [personalPricing, setPersonalPricing] = useState<PricingData[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  const fetchPricingData = useCallback(async () => {
    try {
      setIsLoading(true)
      setError(null)
      
      const pricingData = await getCardPricing({ entity: "ALL" })

      if (pricingData) {
        const data = pricingData?.data?.data
        
        if (pricingData?.error) {
          setError('Erreur lors de la récupération des prix')
          setOrgPricing([])
          setPersonalPricing([])
          return
        }

        if (data) {
          const organizationPricing = _.filter(
            data,
            (pricing) => pricing.entityId === "ORGANIZATION"
          )
          
          const personalPricingData = _.filter(
            data,
            (pricing) => pricing.entityId === "PERSONAL"
          )

          setOrgPricing(organizationPricing || [])
          setPersonalPricing(personalPricingData || [])
        }
      }
    } catch (err) {
      setError('Erreur lors de la récupération des prix')
      setOrgPricing([])
      setPersonalPricing([])
    } finally {
      setIsLoading(false)
    }
  }, [])

  useEffect(() => {
    fetchPricingData()
  }, [fetchPricingData])

  return {
    orgPricing,
    personalPricing,
    isLoading,
    error,
    refetch: fetchPricingData
  }
}
